import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDownIcon } from 'lucide-react';
import { FadeIn } from './ui/FadeIn';
const faqs = [{
  question: 'O ebook é digital ou físico?',
  answer: 'O ebook é 100% digital. Após a compra, você recebe acesso imediato ao material em formato PDF diretamente no seu email, podendo ler no celular, tablet ou computador.'
}, {
  question: 'Preciso de experiência prévia para começar?',
  answer: 'Não! O ebook foi feito especialmente para iniciantes. Ensinamos tudo do absoluto zero, desde a escolha dos materiais básicos até a venda da sua primeira vela.'
}, {
  question: 'Como recebo o acesso ao ebook e aos bônus?',
  answer: 'Após a confirmação do pagamento (que é imediata no PIX ou cartão de crédito), você recebe um email automático com o link seguro para download de todo o material e bônus.'
}, {
  question: 'E se eu não gostar do conteúdo?',
  answer: 'Você tem 7 dias de garantia incondicional. Se você achar que o conteúdo não é para você, basta enviar um único email e devolvemos 100% do seu dinheiro, sem burocracia.'
}, {
  question: 'Posso imprimir o ebook?',
  answer: 'Sim! O ebook é disponibilizado em formato PDF de alta resolução e foi formatado para que você possa imprimi-lo sem problemas para consultar quando quiser.'
}];
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-24 bg-white" data-id="element-30">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-31">
        <FadeIn className="text-center mb-16" data-id="element-32">
          <h2 className="font-serif text-3xl md:text-4xl lg:text-5xl font-bold text-brand-brown mb-4" data-id="element-33">
            Dúvidas? Temos as respostas
          </h2>
          <p className="text-lg text-brand-brown/70" data-id="element-34">
            As perguntas mais comuns sobre o Ebook Acenda
          </p>
        </FadeIn>

        <div className="space-y-4" data-id="element-35">
          {faqs.map((faq, index) => {
          const isOpen = openIndex === index;
          return <FadeIn key={index} delay={index * 0.1} data-id="element-36">
                <div className="bg-brand-cream/30 rounded-2xl overflow-hidden border border-brand-blush hover:border-brand-rose/30 transition-colors" data-id="element-37">
                  <button onClick={() => setOpenIndex(isOpen ? null : index)} className="w-full px-6 py-6 flex items-center justify-between text-left focus:outline-none" aria-expanded={isOpen} data-id="element-38">
                    <span className="font-serif text-lg md:text-xl font-bold text-brand-brown pr-4" data-id="element-39">
                      {faq.question}
                    </span>
                    <motion.div animate={{
                  rotate: isOpen ? 180 : 0
                }} transition={{
                  duration: 0.3,
                  ease: 'easeInOut'
                }} className={`shrink-0 p-1 rounded-full ${isOpen ? 'bg-brand-rose text-white' : 'bg-white text-brand-rose shadow-sm'}`} data-id="element-40">
                      <ChevronDownIcon className="w-5 h-5" data-id="element-41" />
                    </motion.div>
                  </button>

                  <AnimatePresence initial={false} data-id="element-42">
                    {isOpen && <motion.div initial={{
                  height: 0,
                  opacity: 0
                }} animate={{
                  height: 'auto',
                  opacity: 1
                }} exit={{
                  height: 0,
                  opacity: 0
                }} transition={{
                  duration: 0.3,
                  ease: 'easeInOut'
                }} data-id="element-43">
                        <div className="px-6 pb-6 pt-2 text-brand-brown/80 leading-relaxed text-lg border-t border-brand-blush/50 mx-6" data-id="element-44">
                          {faq.answer}
                        </div>
                      </motion.div>}
                  </AnimatePresence>
                </div>
              </FadeIn>;
        })}
        </div>
      </div>
    </section>;
}